<template>
  <base-wrapper>
    <div class="space-y-8">
      <div class="grid grid-cols-6">
        <base-widget label="Total Laporan Tervalidasi" :value="0" />
      </div>

      <section class="space-y-4">
        <div class="flex items-center justify-end gap-2">
          <base-input
            type="text"
            label="Kode Kantor"
            :shadow="false"
            placeholder="Cari kode kantor SC"
            debounce
            v-model="filterOrderBundles.searchOffice"
            @native-input="loadOrderBundles"
          />
          <base-input type="text" label="Laporan">
            <base-select
              :shadow="false"
              :options="[
                { key: 'null', value: null, label: 'Semua' },
                { key: 'manual', value: 'manual', label: 'Laporan Manual' },
                { key: 'system', value: 'system', label: 'Laporan Otomatis' },
              ]"
              v-model="filterOrderBundles.validatedBy"
              @change="loadOrderBundles"
            />
          </base-input>
          <base-input type="text" label="Status Validasi">
            <base-select
              :shadow="false"
              :options="[
                { key: 'null', value: null, label: 'Semua' },
                { key: 'true', value: true, label: 'Tervalidasi' },
                { key: 'false', value: false, label: 'Belum Tervalidasi' },
              ]"
              v-model="filterOrderBundles.isValidated"
              @change="loadOrderBundles"
            />
          </base-input>
          <period-select with-label v-model="filterOrderBundles.periodId" />
          <base-input
            type="text"
            label="Kode"
            :shadow="false"
            placeholder="Cari kode atau nama"
            debounce
            v-model="filterOrderBundles.search"
            @native-input="loadOrderBundles"
          />
        </div>
        <datatable
          :total="orderBundles.meta.page.total"
          :perPage="orderBundles.meta.page.perPage"
          :currentPage="orderBundles.meta.page.currentPage"
          @pagechanged="onChangePage"
          :columns="[
            {
              id: 'code',
              name: 'Nomor Laporan',
            },
            {
              id: 'description',
              name: 'Catatan',
            },
            {
              id: 'total',
              name: 'Total Laporan',
              theadClass: 'text-right',
            },
            {
              id: 'status',
              name: 'Status',
              theadClass: 'text-center',
            },
          ]"
        >
          <template #tbody="{ classes }">
            <tr
              v-for="orderBundle in orderBundles.data"
              :key="orderBundle.id"
              :class="[
                classes.tr,
                'cursor-pointer bg-white hover:bg-green-100',
              ]"
              @click="onOpenDetail(orderBundle)"
            >
              <td :class="classes.td">
                <p class="font-bold text-gray-900">
                  {{ orderBundle.attributes.code }}
                </p>
                <p>
                  {{ orderBundle.attributes.name ?? '-' }}
                </p>
                <p>
                  {{ orderBundle.attributes.createdAt | formatDate }}
                </p>
              </td>
              <td :class="classes.td">
                {{ orderBundle.attributes.description ?? '-' }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{ orderBundle.attributes.bundle_report_price | toCurrency }}
              </td>
              <td :class="[classes.td, 'text-center']">
                <base-badge
                  :color="getOrderBundleStatus(orderBundle).color"
                  >{{
                    getOrderBundleStatus(orderBundle).text
                  }}</base-badge
                >
              </td>
            </tr>
          </template>
          <template #tfoot="{ classes }">
            <tr :class="classes.tr">
              <td :class="classes.td" colspan="2">Total</td>
              <td :class="[classes.td, 'text-right']">
                {{ orderBundles.meta.total_bundle_report_price | toCurrency }}
              </td>
            </tr>
          </template>
        </datatable>
      </section>

      <view-order-bundle-modal
        :visible="detailModal.visible"
        :order-bundle-id="detailModal.id"
        @close="detailModal.visible = false"
      />
    </div>

    <loading v-if="loadingCurrentPeriod || loadingOrderBundles" />
  </base-wrapper>
</template>

<script>
import Datatable from '@/components/base/Datatable';
import BaseWidget from '@/components/base/BaseWidget.vue';
import PeriodSelect from '@/components/period/period-select.vue';
import { requestMixin } from '@/mixins/request/request';
import ViewOrderBundleModal from '@/components/order-bundles/view-order-bundle-modal.vue';

export default {
  mixins: [requestMixin],
  components: {
    Datatable,
    BaseWidget,
    PeriodSelect,
    ViewOrderBundleModal,
  },
  data() {
    return {
      detailModal: {
        id: null,
        visible: false,
      },
      filterOrderBundles: {
        searchOffice: null,
        validatedBy: null,
        isValidated: null,
        periodId: null,
        search: null,
      },
      loadingCurrentPeriod: false,
      loadingOrderBundles: false,
      orderBundles: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  methods: {
    getOrderBundleStatus(orderBundle) {
      if (orderBundle.attributes.is_canceled) {
        return {
          color: 'red',
          text: 'Dibatalkan'
        }
      }

      if (orderBundle.attributes.is_validated) {
        return {
          color: 'green',
          text: 'Tervalidasi'
        }
      }

      return {
        color: 'yellow',
        text: 'Belum Tervalidasi'
      }
    },
    async loadCurrentPeriod() {
      this.loadingCurrentPeriod = true;

      const [res, err] = await this.request(
        '/api/v1/periods/-actions/get-current-period'
      );

      if (!err) {
        this.filterOrderBundles.periodId = res.data.id;
      }

      this.loadingCurrentPeriod = false;
    },
    async loadOrderBundles(params) {
      this.loadingOrderBundles = true;

      const [res, err] = await this.request('/api/v1/order-bundles', {
        params: {
          'fields[order-bundles]':
            'code,name,description,createdAt,bundle_report_price,is_validated,is_canceled',
          'filter[is_submitted]': true,
          'filter[is_validated]': this.filterOrderBundles.isValidated,
          'filter[search]': this.filterOrderBundles.search,
          'filter[creator_mode]': this.filterOrderBundles.validatedBy,
          'filter[office_type]': 'stockist_center',
          'page[size]': 5,
          ...params,
        },
      });

      if (!err) {
        this.orderBundles = res;
      }

      this.loadingOrderBundles = false;
    },
    onChangePage(page) {
      this.loadOrderBundles({
        'page[number]': page,
      });
    },
    onOpenDetail(orderBundle) {
      this.detailModal.id = orderBundle.id;
      this.detailModal.visible = true;
    },
  },
  created() {
    this.loadCurrentPeriod();
    this.loadOrderBundles();
  },
};
</script>
